const ReloadSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 13"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.967 7.02a4 4 0 11-4.963-4.393c1.95-.5 3.968.503 4.713 2.373"
    />
    <path
      stroke="#00AB6B"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 2.5V5H7.5"
    />
  </svg>
);

export default ReloadSvg;
